module.exports = __webpack_public_path__ + "img/report-sample-02@3x.245da77a.png";